import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Drawer, Typography } from '@mui/material';
// hooks
import useResponsive from '../../componentes/useResponsive';
// components
import Scrollbar from '../../componentes/Scrollbar';
import MenuSection from './MenuSection';
//
import menuConfig from './MenuConfig';
import { workWithLocalStorage } from '../../auxiliares/funciones';
import { useCentro } from '../../contextos/CentroContext';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDesktopSidebarOpen'
})(({ theme, isDesktopSidebarOpen }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: isDesktopSidebarOpen ? DRAWER_WIDTH : 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  isDesktopSidebarOpen: PropTypes.bool
};

// eslint-disable-next-line react/prop-types
export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar, isDesktopSidebarOpen = true, setTabs }) {
  const { pathname } = useLocation();
  const { centro } = useCentro();

  const isDesktop = useResponsive('up', 'lg');

  const user = workWithLocalStorage('get', 'usuario', null);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' }
      }}
    >
      <Box sx={{ px: 2.5, py: 3, paddingBottom: 0, display: 'inline-flex' }}>
        <img src="../logo.png" alt="logo" />
      </Box>
      <Box sx={{ px: 1.5, py: 1, paddingBottom: 0, display: 'inline-flex' }}>
        <Typography variant="body" sx={{ color: '#164baf', fontWeight: 'bold' }}>
          {centro.nombre}
        </Typography>
      </Box>

      <Box sx={{ px: 1.5, py: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#0F172A' }}>
          {user ? user.nombre : ''}
        </Typography>
        <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600 }}>
          {user && Number(user.idPerfil || user.perfil) === 2 ? '📱 Perfil Dispositivo' : '🖥️ Perfil Mostrador'}
        </Typography>
      </Box>

      <MenuSection setTabs={setTabs} menuConfig={menuConfig} onCloseSidebar={onCloseSidebar} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle isDesktopSidebarOpen={isDesktopSidebarOpen}>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open={isDesktopSidebarOpen}
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed'
            }
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
